module.exports = __webpack_public_path__ + "img/TriviaCrack.94139b4a.png";